export const LOGO_URL = "/progere-logo.png";

// Static fallback used across landing (also served by API /modules)
export const MODULES = [
  {
    key: "punch",
    name: "PROGÈRE PUNCH",
    tagline: "Gestion du temps & chantier",
    description:
      "Gestion du temps, feuilles de temps, géolocalisation, chantier, rapports CCQ.",
    icon: "Clock",
    color: "gold",
    subdomain: "https://punch.progere.ca",
    path: "/punch",
    premium: null,
  },
  {
    key: "crm",
    name: "PROGÈRE CRM",
    tagline: "Clients & ventes",
    description:
      "Gestion clients, pipeline, suivis, ventes, soumissions, relances.",
    icon: "Users",
    color: "red",
    subdomain: "https://crm.progere.ca",
    path: "/crm",
    premium: null,
  },
  {
    key: "erp",
    name: "PROGÈRE ERP",
    tagline: "Projets & ressources",
    description:
      "Gestion de projets, documents, échéanciers, achats, inventaire, ressources.",
    icon: "Boxes",
    color: "gold",
    subdomain: "https://erp.progere.ca",
    path: "/erp",
    premium: "TAKE OFF",
    construction: true,
  },
  {
    key: "compta",
    name: "PROGÈRE COMPTA",
    tagline: "Comptabilité & paie",
    description:
      "Comptabilité, facturation, dépenses, paie, CCQ, rapports financiers.",
    icon: "Calculator",
    color: "red",
    subdomain: "https://compta.progere.ca",
    path: "/compta",
    premium: "PAIE",
    construction: true,
  },
  {
    key: "devis-ai",
    name: "PROGÈRE DEVIS AI",
    tagline: "Estimation intelligente",
    description:
      "Estimation et création de devis assistées par intelligence artificielle.",
    icon: "Sparkles",
    color: "gold",
    subdomain: "https://devisai.progere.ca",
    path: "/devis-ai",
    premium: null,
    construction: false,
  },
  {
    key: "support",
    name: "PROGÈRE SUPPORT",
    tagline: "Aide & assistance",
    description:
      "Centre d'aide, billets de support, documentation, assistance client.",
    icon: "LifeBuoy",
    color: "red",
    subdomain: "https://support.progere.ca",
    path: "/support",
    premium: null,
  },
];

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/f66e0e14-b56e-4de5-b0fd-8ad35555866a/images/de81b10d78283ecd1ad4e35f102dfc1d2cc22c3ef6dcb2a17261078763b95fdf.png",
  ecosystem: "https://images.unsplash.com/photo-1624533358643-7336036c9482",
  construction:
    "https://static.prod-images.emergentagent.com/jobs/f66e0e14-b56e-4de5-b0fd-8ad35555866a/images/304e26cc110198bac69bfc84a61be0731f008294a16011011543ce31cfb2c70f.png",
};
